import { DashboardPromotionalCards } from "./DashboardPromotionalCards";

interface MainDashboardProps {
  firstName: string;
  lastName: string;
}

export const MainDashboard = ({ firstName, lastName }: MainDashboardProps) => {
  console.log("MainDashboard rendering with:", { firstName, lastName });
  
  return (
    <>
      <DashboardPromotionalCards />
    </>
  );
};